import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-collapse-arrow',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './collapse-arrow.component.html',
  styleUrl: './collapse-arrow.component.css'
})
export class CollapseArrowComponent {
  @Input() isOpen = false;
}
